/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { EPlotType, EVehicleStatusType, IClusterBalloon, IClusterBalloonItem, IClusterBalloonRightClickParams, IPoint, IUserSettings } from '../../../core/models';

@Component({
  selector: 'fm-cluster-balloon',
  templateUrl: './cluster-balloon.component.html',
  styleUrls: ['./cluster-balloon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClusterBalloonComponent {
  @Input()
  balloon: IClusterBalloon;
  @Input()
  userSettings: IUserSettings;

  @Output()
  zoomTo = new EventEmitter<IClusterBalloon>();
  @Output()
  itemClicked = new EventEmitter<IClusterBalloonItem>();
  @Output()
  itemRightClicked = new EventEmitter<IClusterBalloonRightClickParams>();

  EPlotType = EPlotType;
  EVehicleStatusType = EVehicleStatusType;

  onZoomTo(): void {
    this.zoomTo.emit(this.balloon);
  }

  onItemClicked(item: IClusterBalloonItem): void {
    this.itemClicked.emit(item);
  }

  onItemRightClick($event: MouseEvent, clusterBalloonItem: IClusterBalloonItem): void {
    const clickPosition: IPoint = {
      x: $event.pageX,
      y: $event.pageY
    };

    const clusterBalloonRightClickParams: IClusterBalloonRightClickParams = {
      clickPosition,
      clusterBalloonItem
    };
    this.itemRightClicked.emit(clusterBalloonRightClickParams);
  }

  hasDriver(item: IClusterBalloonItem): boolean {
    if (item.driver) {
      const driver = item.driver.trim();
      if (driver !== ',' && driver !== '') {
        return true;
      }
    }
    return false;
  }
}
